import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { TTeeOnPaymentAccount, TTeeOnPaymentRepresentative } from "redux/reducers/models/transaction";


export async function GetTeeOnPaymentAccounts(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TTeeOnPaymentAccount>(
    APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PutTeeOnPaymentAccounts(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIPut(
    APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account"),
    params,
    useGlobalLoader,
    token,
  );
}

export interface IActivateAccountParams {
  email?: string;
  company_name: string;
  company_phone: string;
  company_address_line_1: string;
  company_address_line_2?: string;
  company_city: string;
  company_country_code: string;
  company_postal: string;
  company_province_name: string;
  company_registration_number: string;
  business_profile_name: string;
  business_profile_mcc: string;
  business_profile_product_description: string;
  business_profile_support_email: string;
  business_profile_support_phone: string;
  business_profile_support_url: string;
  business_profile_url: string;


}

export async function PutActivateAccount(useGlobalLoader: boolean, params?: IActivateAccountParams) {
  return await APIPut(
    APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account/activate"),
    params,
    useGlobalLoader,
  );
}

export async function PutAcceptTerms(useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account/accept"), null, useGlobalLoader);
}

/* Retrieve tee on payment representative(s) */
export async function GetTeeOnPaymentRepresentative(params: any, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TTeeOnPaymentRepresentative[]>(
    APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account/person"),
    params,
    useGlobalLoader,
    token,
  );
}

export type TPostTeeOnPaymentRepresentative = {
  first_name: string;
  last_name: string;
  address_line_1: string;
  city: string;
  postal: string;
  province_id: number;
  country_id?: number;
  dob_day: number;
  dob_month: number;
  dob_year: number;
  relationship: {
    director: boolean;
    executive: boolean;
    owner: boolean;
    representative: boolean;
  };
  id_number: string;
  phone: string;
  email: string;
};

/* Add a new tee on payment representative */
export async function PostTeeOnPaymentRepresentative(
  params: TPostTeeOnPaymentRepresentative,
  useGlobalLoader: boolean,
) {
  return await APIPost(
    APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account/person"),
    params,
    useGlobalLoader,
  );
}


export type TPutTeeOnPaymentRepresentative = {
  person_id: string;
  first_name: string;
  last_name: string;
  email: string;
  relationship: {
    director: boolean;
    executive: boolean;
    owner: boolean;
    representative: boolean;
  };
};

/* Update a tee on payment representative */
export async function PutTeeOnPaymentRepresentative(params: TPutTeeOnPaymentRepresentative, useGlobalLoader: boolean) {
  return await APIPut(
    APIUrl(AdminType.FacilityAdmin, "/payment/tee-on-payment/account/person"),
    params,
    useGlobalLoader,
  );
}
